import { Mutation } from './types';

export default {
  [Mutation.SET_ALLOWED_CHARS](state, allowedNameChars) {
	state.allowedNameChars = allowedNameChars;
  },
  [Mutation.SET_VALIDATION_MESSAGE] (state, message) {
    state.message = message;
  },
  [Mutation.SET_FORM_SUBMITTED](state, submittedFlag) {
    state.formSubmitted = submittedFlag;
    console.log('SET_FORM_SUBMITTED : '+state.formSubmitted);
  }
};